import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faLinkedin, faGithub, faTelegram } from '@fortawesome/free-brands-svg-icons';
import { faUser, faHandshake } from '@fortawesome/free-regular-svg-icons';
import logo from '../assets/img/logo.svg';
import styles from '../styles/components/navbar.module.css';
import globalStyles from '../styles/global.module.css';

const Navbar = () => {
  return (
    <nav className={styles.navbar}>
      <div className={styles.navbarContainer}>
        <div className={styles.navbarBrand}>
          <a className={styles.navbarItem} href="/">
            <img width="115" src={logo} alt="Hi-Tech Business Hub" />
          </a>
        </div>
        <div className={styles.navbarEnd}>
          <a className={styles.navbarItem} href="https://www.instagram.com/hitechbusinesshub" target="_blank" rel="noopener noreferrer">
            <span className={globalStyles.icon}>
              <FontAwesomeIcon icon={faInstagram} />
            </span>
          </a>
          <a className={styles.navbarItem} href="https://www.facebook.com/Hi-Tech-Business-Hub-105515512209960" target="_blank" rel="noopener noreferrer">
            <span className={globalStyles.icon}>
              <FontAwesomeIcon icon={faFacebook} />
            </span>
          </a>
          <a className={styles.navbarItem} href="https://www.linkedin.com/company/hi-tech-business-hub" target="_blank" rel="noopener noreferrer">
            <span className={globalStyles.icon}>
              <FontAwesomeIcon icon={faLinkedin} />
            </span>
          </a>
          <a className={styles.navbarItem} href="https://t.me/+NbqPJ1erXz0zMGIy" target="_blank" rel="noopener noreferrer">
            <span className={globalStyles.icon}>
              <FontAwesomeIcon icon={faTelegram} />
            </span>
          </a>
          <span className={styles.navbarItem}>
            <a className={styles.navbarButton} href="mailto:hitech.business.hub@gmail.com">
              <span className={globalStyles.icon}>
                <FontAwesomeIcon icon={faUser} />
              </span>
              <span>Join the team</span>
            </a>
          </span>
          <span className={styles.navbarItem}>
            <a className={styles.navbarButton} href="https://docs.google.com/forms/d/1nFclNcpENZMT9bsmf9uTawc3NwFGKNDqhBgVsW0tWsk/viewform" target="_blank" rel="noopener noreferrer">
              <span className={globalStyles.icon}>
                <FontAwesomeIcon icon={faHandshake} />
              </span>
              <span>Became as partner</span>
            </a>
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 